import React, { useRef } from "react";
import { Card, Form, Row, Col, Button } from "react-bootstrap";
import { useState } from "react";
import DoctorSearch from "../doctor/DoctorSearch";
import { postFormData } from "../../Helper";
import { toast } from "react-toastify";

const IPDRegistration = ({ onNewAdmission }) => {
  // document.title = "IPD Addmission Form";
  const [validated, setValidated] = useState(false);
  const [paymentRoute, setPaymentRoute] = useState({
    scheme: false,
    insurance: false,
    corporate: false,
  });
  const referringDoctorRef = useRef({});
  const admittingDoctorRef = useRef({});
  const handleReferringSearch = (selected) => {
    const doc = referringDoctorRef.current;
    if (selected) {
      doc.contact.readOnly = true;
      doc.registration.readOnly = true;
      referringDoctorRef.current.contact.value = selected.contact;
      referringDoctorRef.current.registration.value = selected.registration;
      // doctorRef.current.referring.fieldset.readonly = true;
    }
  };

  const handleReferringBlur = (e) => {
    console.log(
      referringDoctorRef.current.docotor.selected(),
      referringDoctorRef.current.docotor.innerText()
    );
    const doc = referringDoctorRef.current;
    if (doc.docotor.selected().length === 0) {
      doc.contact.readOnly = false;
      doc.registration.readOnly = false;
      doc.contact.value = "";
      doc.registration.value = "";

      //(doc.docotor.innerText().trim() !== '')
    }
  };

  const handleAdmittingSearch = (selected) => {
    const doc = admittingDoctorRef.current;
    if (selected) {
      doc.contact.readOnly = true;
      doc.registration.readOnly = true;
      doc.contact.value = selected.contact;
      doc.registration.value = selected.registration;
      // doctorRef.current.admitting.fieldset.readonly = true;
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();
    // e.stopPropogation();
    let error = false;
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      error = true;
    }
    setValidated(true);
    if (error) return false;

    const admissionData = await postFormData(
      process.env.REACT_APP_API_ENDPOINT + "patient/ipd",
      new FormData(form)
    );
    if (admissionData.success) {
      onNewAdmission(admissionData.response);
    } else {
      toast.error("Something went wrong. Try again!");
    }
    console.log(admissionData);
  }

  const handlePaymentRouteCheck = ({ target }) => {
    let swtiches = { ...paymentRoute };
    if (target.id === "scheme-switch") {
      swtiches.scheme = target.checked;
      swtiches.insurance = target.checked ? false : swtiches.insurance;
    } else if (target.id === "insurance-switch") {
      swtiches.insurance = target.checked;
    } else if (target.id === "corporate-switch") {
      swtiches.corporate = target.checked;
    }
    setPaymentRoute(swtiches);
  };
  return (
    <>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <fieldset>
          <legend className="border-bottom border-success">
            Emergency Contact Information
          </legend>
          <Row xs={2}>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Contact Person Name</Form.Label>
                <Form.Control
                  name="emergencyPerson"
                  type="text"
                  placeholder="Contact Person Name"
                  required
                  autoFocus
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Relation with Patient</Form.Label>
                <Form.Select
                  aria-label="Relation with Patient"
                  required
                  name="relationWithPatient"
                  // value={formInputData.state}
                  // onChange={handleInputChange}
                >
                  <option value="">Select</option>
                  <option value="father">Father</option>
                  <option value="mother">Mother</option>
                  <option value="brother">Brother</option>
                  <option value="sister">Sister</option>
                  <option value="spouse">Spouse</option>
                  <option value="cousin">Cousin</option>
                  <option value="friend">Friend</option>
                  <option value="other">Other</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Contact Number</Form.Label>
                <Form.Control
                  type="text"
                  name="emergencyContact"
                  placeholder="Contact No"
                  required
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Email"
                  name="emergencyEmail"
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <Form.Control as="textarea" rows={3} name="emergencyAddress" />
          </Form.Group>
        </fieldset>

        <fieldset>
          <legend className="border-bottom border-success">
            Referring Doctor's Information
          </legend>
          <Row xs={2}>
            <Col xs={12}>
              <Form.Group className="mb-3">
                <Form.Label>Doctor's Name</Form.Label>
                <DoctorSearch
                  optionalProps={{
                    inputProps: { name: "referring_doctor" },
                    onBlur: handleReferringBlur,
                    autoFocus: false,
                  }}
                  clearAfterChange={false}
                  onChange={handleReferringSearch}
                  ref={(el) => (referringDoctorRef.current["docotor"] = el)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Contact Number</Form.Label>
                <Form.Control
                  name="referring_contact"
                  ref={(el) => (referringDoctorRef.current["contact"] = el)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Registration Number</Form.Label>
                <Form.Control
                  name="referring_registration"
                  ref={(el) =>
                    (referringDoctorRef.current["registration"] = el)
                  }
                />
              </Form.Group>
            </Col>
          </Row>
        </fieldset>
        <fieldset>
          <legend className="border-bottom border-success">
            Admitting Doctor's Information
          </legend>
          <Row xs={2}>
            <Col xs={12}>
              <Form.Group className="mb-3">
                <Form.Label>Admitting Doctor</Form.Label>
                <DoctorSearch
                  clearAfterChange={false}
                  optionalProps={{
                    name: "admitting_doctor",
                    autoFocus: false,
                  }}
                  onChange={handleAdmittingSearch}
                  ref={(el) => (admittingDoctorRef.current["doctor"] = el)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Contact Number</Form.Label>
                <Form.Control
                  name="admitting_contact"
                  ref={(el) => (admittingDoctorRef.current["contact"] = el)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Registration Number</Form.Label>
                <Form.Control
                  name="admitting_registration"
                  ref={(el) =>
                    (admittingDoctorRef.current["registration"] = el)
                  }
                />
              </Form.Group>
            </Col>
          </Row>
        </fieldset>
        <fieldset>
          <legend className="border-bottom border-success">
            Package Detail
          </legend>
          <Row xs={2}>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>package name</Form.Label>
                <Form.Select name="package">
                  <option>Select Package</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Package Price</Form.Label>
                <Form.Control name="packagePrice"></Form.Control>
              </Form.Group>
            </Col>
          </Row>
        </fieldset>
        <fieldset>
          <legend className="border-bottom border-success">Bed Detail</legend>
          <Row xs={2}>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>building name</Form.Label>
                <Form.Select name="building"></Form.Select>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>floor number</Form.Label>
                <Form.Select name="floor"></Form.Select>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>ward name</Form.Label>
                <Form.Select name="ward"></Form.Select>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>bed number</Form.Label>
                <Form.Select name="bed"></Form.Select>
              </Form.Group>
            </Col>
          </Row>
        </fieldset>

        <fieldset>
          <legend>Insurance/Payee Detail</legend>
          <Form.Check
            type="switch"
            id="scheme-switch"
            label="Scheme"
            checked={paymentRoute.scheme}
            onChange={handlePaymentRouteCheck}
          />
          {paymentRoute.scheme && (
            <Card className="mb-3">
              <Card.Body>
                <Row xs={2}>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Scheme Name</Form.Label>
                      <Form.Control name="scheme_name"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Scheme Authority</Form.Label>
                      <Form.Control name="scheme_authority"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Primary Member ID</Form.Label>
                      <Form.Control name="scheme_primary_member_id"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Card Number</Form.Label>
                      <Form.Control name="scheme_card_number"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Valid Upto</Form.Label>
                      <Form.Control
                        type="month"
                        name="scheme_validity"
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Patient Member Id</Form.Label>
                      <Form.Control name="scheme_patient_id"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Card Number</Form.Label>
                      <Form.Control name="scheme_patient_card"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Valid Upto</Form.Label>
                      <Form.Control
                        type="month"
                        name="scheme_patient_card_validity"
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}
          <Form.Check
            type="switch"
            id="insurance-switch"
            label="Insurance"
            checked={paymentRoute.insurance}
            disabled={paymentRoute.scheme}
            onChange={handlePaymentRouteCheck}
          />
          {paymentRoute.insurance && (
            <Card className="mb-3">
              <Card.Body>
                <Row xs={2}>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Payer Name</Form.Label>
                      <Form.Control name="insurance_payer_name"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>TPA Name</Form.Label>
                      <Form.Control name="insurance_tpa_name"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Primary Member ID</Form.Label>
                      <Form.Control name="insurance_member_id"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Card Number</Form.Label>
                      <Form.Control name="insurance_card_number"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Valid Upto</Form.Label>
                      <Form.Control
                        type="month"
                        name="insurance_card_validity"
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Patient Member Id</Form.Label>
                      <Form.Control name="insurance_patient_id"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Card Number</Form.Label>
                      <Form.Control name="insurance_patient_card"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Valid Upto</Form.Label>
                      <Form.Control
                        type="month"
                        name="insurance_patient_card_validity"
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}

          <Form.Check
            type="switch"
            id="corporate-switch"
            label="Corporate"
            checked={paymentRoute.corporate}
            onChange={handlePaymentRouteCheck}
          />
          {paymentRoute.corporate && (
            <Card className="mb-3">
              <Card.Body>
                <Row xs={2}>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Company Name</Form.Label>
                      <Form.Control name="corporate_company_name"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Employee Name</Form.Label>
                      <Form.Control name="corporate_employee_name"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Employee ID</Form.Label>
                      <Form.Control name="corporate_employee_id"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Relation with Patient</Form.Label>
                      <Form.Select
                        aria-label="Relation with Patient"
                        required
                        name="corporate_relation_with_patient"
                        // value={formInputData.state}
                        // onChange={handleInputChange}
                      >
                        <option value="">Father</option>
                        <option value="2">Mother</option>
                        <option value="2">Brother</option>
                        <option value="2">Sister</option>
                        <option value="2">Self</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Primary Member ID</Form.Label>
                      <Form.Control name="corporate_primary_member_id"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Card Number</Form.Label>
                      <Form.Control name="corporate_card_number"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Valid Upto</Form.Label>
                      <Form.Control
                        type="month"
                        name="corporate_card_validity"
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Patient Member Id</Form.Label>
                      <Form.Control name="corporate_patient_id"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Card Number</Form.Label>
                      <Form.Control name="corporate_patient_card_number"></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Valid Upto</Form.Label>
                      <Form.Control
                        type="month"
                        name="corporate_patient_card_validity"
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}
        </fieldset>

        <fieldset className="mt-3">
          <div className="d-flex justify-content-between">
            <Button type="reset" variant="warning">
              Reset
            </Button>
            <Button type="submit" variant="success">
              Submit
            </Button>
          </div>
        </fieldset>
      </Form>
    </>
  );
};

export default IPDRegistration;
